<template>
  <div>
    <div class="banner">
      <img src="../../assets/img/resdetailsBan.png" alt />
      <div class="resNav">
        <div class="main">
          <span>您的位置：</span>
          <span>首页</span>
          <span>></span>
          <span>资源库</span>
          <span>></span>
          <span>资源库详情</span>
        </div>
      </div>
    </div>
    <div class="detcenter">
      <div class="main">
        <div class="Info">
          <div class="line"></div>
          <div class="InfoText">简介</div>
          <div
            class="infodet"
          >2019年，国务院发布《国家职业教育改革实施方案》，方案中提出构建职业教育国家标准，深化复合型技术技能人才培养培训模式改革，借鉴国际职业培训普遍做法，制定工作方案和具体的管理方法，在职业院校、应用型本科高校启动1+x证书（‘学历证书+若干职业技能等级证书’）试点工作。 加快推进职业教育国家“学分银行”建设，实现学习成果的认定、积累和转换，促进学历证书与职业技能等级证书互通。 2019年，国务院发布《国家职业教育改革实施方案》，方案中提出构建职业教育国家标准，深化复合型技术技能人才培养培训模式改革，借鉴国际职业培训普遍做法，制定工作方案和具体的管理方法，在职业院校、应用型本科高校启动1+x证书（‘学历证书+若干职业技能等级证书’）试点工作。 加快推进职业教育国家“学分银行”建设，实现学习成果的认定、积累和转换，促进学历证书与职业技能等级证书互通。 2019年，国务院发布《国家职业教育改革实施方案》，方案中提出构建职业教育国家标准，深化复合型技术技能人才培养培训模式改革，借鉴国际职业培训普遍做法，制定工作方案和具体的管理方法，在职业院校、应用型本科高校启动1+x证书（‘学历证书+若干职业技能等级证书’）试点工作。 加快推进职业教育国家“学分银行”建设，实现学习成果的认定、积累和转换，促进学历证书与职业技能等级证书互通。 2019年，国务院发布《国家职业教育改革实施方案》，方案中提出构建职业教育国家标准，深化复合型技术技能人才培养培训模式改革，借鉴国际职业培训普遍做法，制定工作方案和具体的管理方法，在职业院校、应用型本科高校启动1+x证书（‘学历证书+若干职业技能等级证书’）试点工作。 加快推进职业教育国家“学分银行”建设，实现学习成果的认定、积累和转换，促进学历证书与职业技能等级证书互通。 2019年，国务院发布《国家职业教育改革实施方案》，方案中提出构建职业教育国家标准，深化复合型技术技能人才培养培训模式改革，借鉴国际职业培训普遍做法，制定工作方案和具体的管理方法，在职业院校、应用型本科高校启动1+x证书（‘学历证书+若干职业技能等级证书’）试点工作。 加快推进职业教育国家“学分银行”建设，实现学习成果的认定、积累和转换，促进学历证书与职业技能等级证书互通。</div>
        </div>
        <div>
          <div class="Info">
            <div class="line"></div>
            <div class="lineText">全部课程</div>
            <router-link to="/repositories/reslist">
              <div class="more">查看更多 / SEE MORE</div>
            </router-link>
          </div>
          <div class="course">
            <el-row :gutter="20">
              <el-col :span="6" v-for="(item,index) in relevant" :key="index">
                <div class="grid-content bg-purple courseItem">
                  <div class="itemImg">
                    <img src="../../assets/img/relevantItem.png" alt />
                  </div>
                  <div class="itemTit">新突破大学英语综合教材</div>
                  <div class="user">马丽 黄群 卢大磊</div>
                  <div
                    class="itemDet"
                  >本课程根据机械制造业岗位任务分析、知识与技能需要，以能力培养为重点，重构机械制造学科体系中的机械制图、极限配合与技术测量、材料及热处理内容，体现了职业教学的实践性、职业性、开放性 本课程根据机械制造业岗位任务分析、知识与技能需要，以能力培养为重点，重构机械制造学科体系中的机械制图、极限配合与技术测量、材料及热处理内容，体现了职业教学的实践性、职业性、开放性。</div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div>
          <div class="Info">
            <div class="line"></div>
            <div class="lineText">全部素材</div>
            <router-link class="more" to="/repositories/sourselist" tag="div">查看更多 / SEE MORE</router-link>
            <!-- <div class="more">查看更多 / SEE MORE</div> -->
          </div>
          <div class="course">
            <el-row :gutter="20">
              <el-col :span="6" v-for="(item,index) in relevant" :key="index">
                <div class="grid-content bg-purple">
                  <div class="itemnewImg">
                    <img src="../../assets/img/relevantItem.png" alt />
                  </div>
                  <div class="itemTit">新突破大学英语综合教材</div>
                  <div class="user">文件大小：10kb</div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      relevant: [{ id: 1 }, { id: 1 }, { id: 1 }, { id: 1 }]
    }
  }
}
</script>
<style lang="scss" scoped>
.banner {
  position: relative;
  width: 100%;
  height: 440px;
  img {
    width: 100%;
    height: 100%;
  }
}
.resNav {
  width: 100%;
  height: 42px;
  background: rgba(0, 0, 0, 0.2);
  position: absolute;
  bottom: 0px;
  span {
    line-height: 42px;
    font-size: 14px;
    color: rgba(204, 204, 204, 1);
  }
}
.Info {
  overflow: hidden;
  padding-bottom: 50px;
  .line {
    float: left;
    width: 10px;
    height: 20px;
    background: rgba(181, 14, 5, 1);
    margin-right: 10px;
  }
  .InfoText {
    font-size: 22px;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
  }
  .lineText {
    float: left;
    font-size: 22px;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
  }
  .infodet {
    overflow: hidden;
    height: 182px;
    font-size: 14px;
    color: rgba(51, 51, 51, 1);
    line-height: 24px;
    margin-top: 20px;
  }
  .more {
    float: right;
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
  }
}
.Info {
  overflow: hidden;
  padding: 50px 0 20px;

  .recommend {
    float: left;
    font-size: 22px;
    color: rgba(51, 51, 51, 1);
  }
}
.courseItem {
  height: 335px;
  overflow: hidden;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e6e6e6;
  .itemImg {
    height: 150px;
    width: 100%;
    img {
      height: 100%;
      width: 100%;
    }
  }
  .itemTit {
    font-size: 16px;
    color: rgba(181, 14, 5, 1);
    margin: 17px 0 22px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .user {
    font-size: 12px;
    color: rgba(102, 102, 102, 1);
    margin-bottom: 22px;
  }
  .itemDet {
    font-size: 13px;
    color: rgba(102, 102, 102, 1);
    line-height: 24px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    height: 97px;
  }
}
.itemnewImg {
  width: 100%;
  height: 110px;
  img {
    height: 100%;
    width: 100%;
  }
}
.itemTit {
  font-size: 16px;
  color: rgba(181, 14, 5, 1);
  margin: 17px 0 22px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.user {
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
  margin-bottom: 50px;
}
</style>